import { BASE_URL as API_BASE_URL } from '../api/constants';

export function getBotWebhookUrl(id: string) {
  const base = API_BASE_URL!.replace(/\/$/, '');
  return `${base}/autotrade-webhooks/${id}`;
}